import * as React from "react";
import type { SVGProps } from "react";
const SvgOnePersonTravelling = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#one-person-travelling_svg__a)">
      <path d="M8 22a1 1 0 0 1-1-1v-5a1 1 0 0 1 .29-.71l.71-.71V11H5v3.58l.71.71A1 1 0 0 1 6 16v5a1 1 0 1 1-2 0v-4.59l-.71-.71A1 1 0 0 1 3 15v-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v4a1 1 0 0 1-.29.7l-.71.71V21a1 1 0 0 1-1 1M6.5 8A2.54 2.54 0 0 1 4 5.62v-1a2.53 2.53 0 0 1 3.444-2.452A2.55 2.55 0 0 1 9.08 4.52L9 5.62A2.54 2.54 0 0 1 6.5 8m0-4c-.39 0-.63.23-.63.52l.06 1a.52.52 0 0 0 1 0l.06-1A.52.52 0 0 0 6.55 4zM18.34 21.1h-4.68A2.66 2.66 0 0 1 11 18.44v-3.68a2.66 2.66 0 0 1 2.66-2.66h4.68A2.66 2.66 0 0 1 21 14.76v3.68a2.66 2.66 0 0 1-2.66 2.66m-4.68-7a.65.65 0 0 0-.66.66v3.68a.65.65 0 0 0 .66.66h4.68a.65.65 0 0 0 .66-.66v-3.68a.65.65 0 0 0-.66-.66z" />
      <path d="M14 22.1a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1M18 22.1a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1M16 13.1a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1" />
      <path d="M18 11.1h-4a1 1 0 0 1 0-2h4a1 1 0 1 1 0 2" />
    </g>
    <defs>
      <clipPath id="one-person-travelling_svg__a">
        <path fill="#fff" d="M3 2h18v20.1H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOnePersonTravelling;
